import { useState } from "react";
import { images } from "./GalaryPhotos";
import Main from "./Router/Main";

function App() {
  const [chatOpen, setChatOpen] = useState(false);
  
  return (
    <Main chatOpen={chatOpen} setChatOpen={setChatOpen} images={images}/>
  );
}

export default App;
